import * as z from 'zod';
export const ParticipantsStatsRowSchema = z.object({
    participantId: z.uuidv7(),
    favoriteCount: z.int().nonnegative(),
    guessCount: z.int().nonnegative(),
});
//# sourceMappingURL=participant.js.map